import { TrackingConstants } from './../../../shared/services/tracking/tracking-constants.service';
import { MessageService } from '../../../services/messages.service';
import { SnackBarService } from '../../../services/snackbar.service';
import { TrackingService } from '../../../shared/services/tracking/google-analytics-events.service';
import { AddSurveyTemplateComponent } from './../addsurveytemplate/add-surveytemplate.component';
import { SurveyManagementService } from './../survey-management.service';
import { SurveyTemplate } from '../../../shared/models/survey/survey-template.model';
import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';


@Component({
  selector: 'surveytemplate-list',
  templateUrl: './surveytemplate-list.component.html',
  styleUrls: ['./surveytemplate-list.component.css']
})

/**
 * Component for display the survey template list.
 *
 * @author mohit.khurana@vernuso.com (Mohit Khurana)
 */
export class SurveyTemplateListComponent implements OnInit {
  dialogRef: MdDialogRef<any>;
  surveyTemplates: SurveyTemplate[];
  selectedTemplate: SurveyTemplate;
  surveyTemplatesLoaded = false;

  constructor(
    public dialog: MdDialog,
    public viewContainerRef: ViewContainerRef,
    private surveyManagementService: SurveyManagementService,
    private snackBarService: SnackBarService,
    private trackingService: TrackingService) { }

  openAddSurveyTemplateDialog(action: string) {
    const config = new MdDialogConfig();
    config.viewContainerRef = this.viewContainerRef;

    this.dialogRef = this.dialog.open(AddSurveyTemplateComponent, config);
    this.dialogRef.componentInstance.selectedTemplate = this.selectedTemplate;
    this.dialogRef.componentInstance.action = action;
    this.dialogRef.afterClosed().subscribe(result => {
      this.dialogRef = null;
      if (result) {
        this.updateSurveyTemplates(action, result);
      }
      this.selectedTemplate = null;
    });
  }

  updateSurveyTemplates(action: string, result: SurveyTemplate) {
    if (action === 'Edit') {
      for(let index in this.surveyTemplates) {
        if (this.surveyTemplates[index].id == this.selectedTemplate.id) {
          this.surveyTemplates[index] = result;
        }
      }
    } else {
      this.surveyTemplates.push(result);
    }
    this.surveyManagementService.setSurveyTemplatesInCache(this.surveyTemplates);
  }

  getSurveyTemplateList() {
    this.surveyManagementService.getSurveyTemplates()
      .subscribe(response => {
        this.surveyManagementService.setSurveyTemplatesInCache(response);
        this.surveyTemplates = response;
      });
  }

  editSurveyTemplate(value: SurveyTemplate): void {
    this.selectedTemplate = value;
    this.openAddSurveyTemplateDialog('Edit');
  }

  deleteSurveyTemplate(selectedTemplate: SurveyTemplate): void {
    const surveyTemplate = new SurveyTemplate();
    surveyTemplate.id = selectedTemplate.id;
    this.surveyManagementService.deleteSurveyTemplate(surveyTemplate)
      .subscribe(response => {
        if (response.flagResult) {
          this.surveyTemplates.splice(this.surveyTemplates.indexOf(selectedTemplate), 1);
          this.surveyManagementService.setSurveyTemplatesInCache(this.surveyTemplates);
        }
        this.trackingService
          .emitEvent(
          TrackingConstants.SURVEY_MANAGEMENT,
          TrackingConstants.DELETE_SURVEY_TEMPLATE,
          TrackingConstants.SUCCESS, 1);
        this.callSnackBarService(response);
      }, err => {
        this.trackingService
          .emitEvent(
          TrackingConstants.SURVEY_MANAGEMENT,
          TrackingConstants.DELETE_SURVEY_TEMPLATE,
          TrackingConstants.FAILURE, 0);
        this.callSnackBarService(err);
      });
  }

  callSnackBarService(response: any) {
    this.snackBarService
      .showStatus(response,
      MessageService.DELETE_SURVEY_TEMPLATE_SUCCESS,
      MessageService.SURVEY_TEMPLATE_FAILURE);
  }

  updateSelectedSurveyTemplate(updatedSurveyTemplate: SurveyTemplate): void {

  }

  deleteSurveyTemplateFromSurveyTemplateList(surveyTemplateId: string): void {

  }

  ngOnInit() {
    this.getSurveyTemplateList();
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/survey/surveytemplatelist/surveytemplate-list.component.ts